import { AGG } from './types';

export const minitop = {
  id: 'minitop',
  label: 'Minitop',
  description: 'Report sintetico multi-canale. Nessun economics.',
  hide_economics: true,
  single_image: true,  // mostra una sola immagine per tutto il report
  sections: [
    {
      id: 'meta',
      title: 'Meta',
      blocks: [
        {
          channel: 'meta',
          kpis: [
            { key: 'date_start',  label: 'Data di inizio',     aggregation: AGG.AUTO_MIN },
            { key: 'date_end',    label: 'Data di fine',       aggregation: AGG.AUTO_MAX },
            { key: 'reach',       label: 'Reach',              aggregation: AGG.SUM },
            { key: 'impressions', label: 'Impression',         aggregation: AGG.SUM },
            { key: 'engagement',  label: 'Engagement',         aggregation: AGG.SUM },
            { key: 'reactions',   label: 'Reactions',          aggregation: AGG.SUM },
            { key: 'video_views', label: 'Riproduzione video', aggregation: AGG.CONDITIONAL, note: 'Se il media è video' },
            { key: 'link_clicks', label: 'Click su link',      aggregation: AGG.SUM },
          ],
        },
      ],
    },
    {
      id: 'meta_demographics',
      title: 'Meta — Demografico Target',
      blocks: [
        {
          channel: 'meta',
          label: 'Demografico del Target basato su impression',
          kpis: [
            { key: 'impressions', label: 'Impression per età × genere', aggregation: AGG.SUM },
          ],
        },
      ],
    },
    {
      id: 'google',
      title: 'Google',
      blocks: [
        {
          channel: 'google',
          kpis: [
            { key: 'date_start',  label: 'Data di inizio', aggregation: AGG.AUTO_MIN },
            { key: 'date_end',    label: 'Data di fine',   aggregation: AGG.AUTO_MAX },
            { key: 'impressions', label: 'Impression',     aggregation: AGG.SUM },
            { key: 'link_clicks', label: 'Click sul link', aggregation: AGG.SUM },
          ],
        },
      ],
    },
    {
      id: 'youtube',
      title: 'YouTube',
      blocks: [
        {
          channel: 'youtube',
          kpis: [
            { key: 'date_start',  label: 'Data di inizio',     aggregation: AGG.AUTO_MIN },
            { key: 'date_end',    label: 'Data di fine',       aggregation: AGG.AUTO_MAX },
            { key: 'impressions', label: 'Impression',         aggregation: AGG.SUM },
            { key: 'video_views', label: 'Riproduzione video', aggregation: AGG.SUM },
            { key: 'link_clicks', label: 'Click sul link',     aggregation: AGG.SUM },
          ],
        },
      ],
    },
    {
      id: 'tiktok',
      title: 'TikTok',
      blocks: [
        {
          channel: 'tiktok',
          kpis: [
            { key: 'date_start',  label: 'Data di inizio',     aggregation: AGG.AUTO_MIN },
            { key: 'date_end',    label: 'Data di fine',       aggregation: AGG.AUTO_MAX },
            { key: 'reach',       label: 'Reach',              aggregation: AGG.SUM },
            { key: 'impressions', label: 'Impression',         aggregation: AGG.SUM },
            { key: 'engagement',  label: 'Engagement',         aggregation: AGG.SUM },
            { key: 'reactions',   label: 'Reactions',          aggregation: AGG.SUM },
            { key: 'video_views', label: 'Riproduzione video', aggregation: AGG.SUM },
            { key: 'link_clicks', label: 'Click su link',      aggregation: AGG.SUM },
          ],
        },
      ],
    },
    {
      id: 'spotify',
      title: 'Spotify',
      blocks: [
        {
          channel: 'spotify',
          kpis: [
            { key: 'date_start',            label: 'Data di inizio',     aggregation: AGG.AUTO_MIN },
            { key: 'date_end',              label: 'Data di fine',       aggregation: AGG.AUTO_MAX },
            { key: 'reach',                 label: 'Reach',              aggregation: AGG.SUM },
            { key: 'impressions',           label: 'Impression',         aggregation: AGG.SUM },
            { key: 'link_clicks',           label: 'Click',              aggregation: AGG.SUM },
            { key: 'video_completion_rate', label: '% di completamento', aggregation: AGG.SUM, unit: 'percent' },
          ],
        },
      ],
    },
  ],
};
